<template>
  <v-container id="Requisition-items">
    <v-data-table
      :headers="headers"
      :items="items"
      dense
      :hide-default-footer="true"
      :disable-sort="true"
      :hide-default-header="true"
    >
      <template v-slot:header="{ props }" v-if="items.length > 0">
        <thead>
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="custom-header"
              style=" border-bottom: thin solid rgb(0 0 0 / 0%);"
            >
              <p>{{ header.text }}</p>
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:body="{ items }">
        <tr v-for="(item, index) in items" :key="index">
          <td class="px-3">
            <v-autocomplete
              v-model="item.product_id"
              :items="products"
              item-text="name"
              item-value="id"
              dense
              outlined
              clearable
              :rules="[rules.required]"
              :loading="isFetchingProducts"
              :filter="() => true"
              @update:search-input="
                (searchTerm) => onSearchProducts(searchTerm)
              "
              placeholder="Search Product Name"
              no-data-text="Search Product name or Product code"
            ></v-autocomplete>
          </td>
          <td class="wider-description px-3">
            <v-text-field
              v-model="item.description"
              placeholder="Description"
              dense
              outlined
              clearable
            ></v-text-field>
          </td>
          <td class="px-3">
            <v-text-field
              v-model.number="item.quantity"
              placeholder="Quantity"
              type="number"
              dense
              outlined
              clearable
            ></v-text-field>
          </td>

          <td class="pb-5">
            <v-icon
              size="30"
              color="red"
              @click="$emit('remove-item', index)"
              class="delete-icon"
            >
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-row class="mt-0" v-if="items.length < 10">
      <v-col class="text-left">
        <v-icon size="40" color="blue" @click="$emit('add-item')"
          >mdi-plus</v-icon
        >
        <span>Add Item</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { RequisitionService } from "@/services/requisition-service.js";

export default {
  name: "ItemsTable",
  props: {
    items: { type: Array, required: true },
    productsArray: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      default: () => [
        { text: "Product", value: "product_id" },
        { text: "Description", value: "description" },
        { text: "Quantity", value: "quantity" },
        { text: "", value: "actions", sortable: false },
      ],
    },
    title: { type: String, default: "Items" },
  },

  data() {
    return {
      isFetchingProducts: false,
      ProductSearchTimeout: null,
      products: [...this.productsArray],
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },

  methods: {
    async onSearchProducts(searchTerm) {
      if (!searchTerm) {
        return;
      }

      try {
        clearTimeout(this.ProductSearchTimeout);
        this.isFetchingProducts = true;
        this.ProductSearchTimeout = setTimeout(async () => {
          const response = await RequisitionService.getProducts(searchTerm);
          const newProducts = response.data.data;
          this.products = [...new Set([...this.products, ...newProducts])];
          console.log(
            "Products fetched : ",
            JSON.parse(JSON.stringify(this.products))
          );
        }, 3000);
      } catch (error) {
        console.error("Error fetching Products:", error);
      } finally {
        this.isFetchingProducts = false;
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: rgba(192, 0, 250, 0.215);
  border-radius: 10px;
}
</style>
